import { EstimatedExposureTime } from '@aloft/toolkit-shared';

const estimatedExposureTimeDays: Record<EstimatedExposureTime, number> = {
  'Less than 30 days': 15,
  '30 - 60 days': 45,
  '60 - 90 days': 75,
  '90 - 120 days': 105,
  '120 - 150 days': 135,
  '150 - 180 days': 165,
  'More than 180 days': 210,
};

const MIN_EXPOSURE_DOM_RATIO = 0.5;
const MAX_EXPOSURE_DOM_RATIO = 2;

export const getEstimatedExposureTimeDays = (exposureTime: EstimatedExposureTime): number =>
  estimatedExposureTimeDays[exposureTime];

export const isEstimatedExposureTimeInconsistentWithDom = (
  exposureTime: EstimatedExposureTime | undefined,
  daysOnMarket?: number,
): boolean => {
  if (!exposureTime || daysOnMarket == null || daysOnMarket <= 0) {
    return false;
  }

  const exposureDays = getEstimatedExposureTimeDays(exposureTime);
  const ratio = exposureDays / daysOnMarket;

  return ratio < MIN_EXPOSURE_DOM_RATIO || ratio > MAX_EXPOSURE_DOM_RATIO;
};
